import { render, staticRenderFns } from "./FinancialArea.vue?vue&type=template&id=b8174e28&scoped=true"
import script from "./FinancialArea.vue?vue&type=script&lang=js"
export * from "./FinancialArea.vue?vue&type=script&lang=js"
import style0 from "./FinancialArea.vue?vue&type=style&index=0&id=b8174e28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8174e28",
  null
  
)

export default component.exports